import { Link } from '@inertiajs/react';
import { Button } from '../../design-system/components';
export default function Error400() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-secondary px-4">
      <div className="text-center">
        <p className="text-6xl font-bold text-fg">400</p>
        <h1 className="mt-4 text-2xl font-semibold text-fg">Bad Request</h1>
        <p className="mt-2 text-fg-secondary">
          The request could not be understood. Please check and try again.
        </p>
        <div className="mt-8">
          <Link href="/">
            <Button>Go Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
